import { Box } from "@mui/material";
import { FC, useCallback, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { alertsUtilizationDataProviderOrdIdSelector } from "@/store/alerts/selectors/utilization-alerts/data/alertsUtilizationDataProviderOrdIdSelector";
import { setAlertsData } from "@/store/alerts/alertsSlice";
import { CommitmentOrganizationSelect } from "@/components/common/commitment-org-select/CommitmentOrganizationSelect";
import { alertsUtilizationDataProviderSelector } from "@/store/alerts/selectors/utilization-alerts/data/alertsUtilizationDataProviderSelector";
import {
  CommitmentCloudProvider,
  ProviderType,
} from "@/services/cloudchipr.api";

export const AlertsUtilizationProviderOrgIdSelect: FC = () => {
  const dispatch = useAppDispatch();
  const selectedOrgId = useAppSelector(
    alertsUtilizationDataProviderOrdIdSelector,
  );
  const selectedProvider = useAppSelector(
    alertsUtilizationDataProviderSelector,
  );
  const selectedValue = useMemo(
    () => ({
      provider: selectedProvider ?? "aws",
      organizationId: selectedOrgId,
    }),
    [selectedOrgId, selectedProvider],
  );

  const handleChange = useCallback(
    (provider: ProviderType, orgId: string) => {
      if (provider === selectedProvider && orgId === selectedOrgId) {
        return;
      }

      dispatch(
        setAlertsData({
          providerOrganisationId: orgId,
          provider: provider as CommitmentCloudProvider,
        }),
      );
    },
    [dispatch, selectedOrgId, selectedProvider],
  );

  return (
    <Box flex={1}>
      <CommitmentOrganizationSelect
        onChange={handleChange}
        selectedOrg={selectedValue}
      />
    </Box>
  );
};
